import React from 'react';
import ComparisonRenderer from '../ComparisonRenderer';
import { VersionLogRootRecord } from '../../version-log/records/VersionLogRootRecord';

const RootRenderer: React.FC<VersionLogRootRecord> = ({ children }) => {
  if (!Array.isArray(children)) {
    return null;
  }
  return <ComparisonRenderer schema={children} />;
};

export default RootRenderer;
